import { FC } from 'react'

import { useRouter } from 'next/navigation'
import styled from 'styled-components'

import { MemberTypeSwitchTab } from 'src/components/molecules'

import { Routes } from 'src/routes'

const Container = styled.div`
  border-radius: var(--s-1) var(--s-1) 0 0;
  overflow: hidden;
`

export type MemberType = 'internal' | 'external'

type Props = {
  selected: MemberType
  select: (type: MemberType) => void
  className?: string
}

export const MemberTypeSwitchTabs: FC<Props> = ({ selected, select, className }) => {
  const router = useRouter()
  const handleSelectTab = (type: MemberType) => {
    const path = type === 'internal' ? Routes.UserList.path : Routes.ExternalUserList.path
    router.push(path)
    select(type)
  }

  return (
    <div className={className}>
      <Container className="tw-flex tw-border-border-secondary tw-border tw-bg-surface-primary">
        <MemberTypeSwitchTab
          text="社内ユーザー"
          isSelected={selected === 'internal'}
          select={() => handleSelectTab('internal')}
        />
        <MemberTypeSwitchTab
          text="社外ユーザー"
          isSelected={selected === 'external'}
          select={() => handleSelectTab('external')}
        />
      </Container>
    </div>
  )
}
